import Vue from "vue";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import App from "./App.vue";
import router from "./router";
import qs from "qs";
import 'default-passive-events'
// import echarts from "echarts";
// 测试播放器功能
// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
// Vue.use(VideoPlayer)

Vue.use(ElementUI);
Vue.config.productionTip = false;
Vue.prototype.$qs = qs;
// Vue.prototype.$echarts = echarts;


// 在定义vue实例时可以指定全局的headers（在路由的get和post方法中定义，只有get的有效。。）-----貌似这里的配置没啥用，还是得在get方法中定义
new Vue({
  router,
  // http: {'Authorization': 'JWT ' + localStorage.getItem('token') },
  render: (h) => h(App),
}).$mount("#app");
